import Data from './Data';

const AnchorBlockSidebar = (props) => {
  return <Data {...props} />;
};

export default AnchorBlockSidebar;
